{
  "scheduleDashboard": {
    "title": "Trip Schedule",
    "alerts": {
      "selectFBO": "Please select an FBO to view the schedule."
    },
    "viewModes": {
      "timeline": "Timeline",
      "timelineTooltip": "View trips in a visual timeline/GANTT chart",
      "table": "Table",
      "tableTooltip": "View trips in a detailed data table"
    },
    "buttons": {
      "createTrip": "Create Trip",
      "bulkImport": "Bulk Import"
    },
    "filters": {
      "locationCount": "Filtered: {{count}} location",
      "statusLabel": "Status",
      "statusOptions": {
        "all": "All Status",
        "scheduled": "Scheduled",
        "active": "Active",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "requested": "Requested",
        "confirmed": "Confirmed",
        "tenant-based": "Tenant-Based",
        "transient": "Transient",
        "hangar": "Hangar"
      },
      "csrStatusOptions": {
        "all": "All Status",
        "requested": "Requested",
        "confirmed": "Confirmed",
        "completed": "Completed",
        "cancelled": "Cancelled"
      },
      "tailNumberLabel": "Filter by Tail Number",
      "tailNumberPlaceholder": "N123AB",
      "showPastTrips": "Show Past Trips"
    },
    "errors": {
      "timelineTitle": "Timeline Error",
      "timelineDescription": "There was an error loading the timeline view. Please try refreshing or switching to table view."
    },
    "emptyState": "No trips scheduled for the selected date range"
  },
  "scheduleList": {
    "columns": {
      "tailNumber": "Tail Number",
      "aircraftModel": "Aircraft Model",
      "type": "Type",
      "arrival": "Arrival",
      "departure": "Departure",
      "status": "Status",
      "notes": "Notes",
      "ownerManager": "Owner/Manager",
      "assignment": "Assignment",
      "actions": "Actions"
    },
    "tooltips": {
      "editTrip": "Edit Trip"
    },
    "dateRange": "Showing trips from {{startDate}} to {{endDate}}",
    "tripCount": "Showing {{filtered}} of {{total}} trips",
    "filters": {
      "tailNumberLabel": "Filter by Tail Number",
      "tailNumberPlaceholder": "e.g. N123AB",
      "statusLabel": "Status",
      "statusOptions": {
        "all": "All Status",
        "scheduled": "Scheduled",
        "active": "Active",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "requested": "Requested",
        "confirmed": "Confirmed",
        "tenant-based": "Tenant-Based",
        "transient": "Transient",
        "hangar": "Hangar"
      },
      "csrStatusOptions": {
        "all": "All Status",
        "requested": "Requested",
        "confirmed": "Confirmed",
        "completed": "Completed",
        "cancelled": "Cancelled"
      }
    },
    "noTripsFound": "No trips found",
    "bulkActions": {
      "selected": "{{count}} selected",
      "setStatus": "Set Status",
      "assignLocation": "Assign Location",
      "cancel": "Cancel Trips",
      "delete": "Delete",
      "clearSelection": "Clear selection",
      "deleteConfirmTitle": "Delete Selected Trips",
      "deleteConfirmMessage": "Are you sure you want to permanently delete {{count}} trip(s)? This action cannot be undone.",
      "deleteConfirmButton": "Delete",
      "cancelConfirmTitle": "Cancel Selected Trips",
      "cancelConfirmMessage": "Are you sure you want to cancel {{count}} trip(s)? This will set their status to 'cancelled'.",
      "cancelConfirmButton": "Cancel Trips",
      "statusSuccess": "Updated status for {{count}} trips",
      "statusPartial": "Updated {{successCount}} trips ({{failCount}} failed)",
      "deleteSuccess": "Deleted {{count}} trips",
      "cancelSuccess": "Cancelled {{count}} trips",
      "assignSuccess": "Assigned {{count}} trips to {{locationName}}"
    }
  },
  "scheduleTimeline": {
    "tooltip": {
      "location": "Location: {{name}}"
    },
    "deleteConfirmation": {
      "title": "Delete Selected Trips",
      "message": "Are you sure you want to delete {{count}} selected trip? This action cannot be undone.",
      "deleteButton": "Delete",
      "cancelButton": "Cancel"
    }
  },
  "scheduledHangarView": {
    "updating": "Updating...",
    "addObstacleDialog": {
      "title": "Add Movable Obstacle",
      "cancelButton": "Cancel",
      "doneButton": "Done"
    },
    "errors": {
      "noData": {
        "title": "No Hangar Data Available",
        "description": "Unable to load hangar information for this time period. Try refreshing the page or selecting a different time.",
        "actionLabel": "Refresh"
      }
    }
  },
  "scheduledRampView": {
    "errors": {
      "noData": {
        "title": "No Ramp Data Available",
        "description": "Unable to load ramp information for this time period. Try refreshing the page or selecting a different time.",
        "actionLabel": "Refresh"
      }
    },
    "addObstacleDialog": {
      "title": "Add Movable Obstacle",
      "buttons": {
        "cancel": "Cancel",
        "done": "Done"
      }
    }
  },
  "assignLocationDialog": {
    "title": "Assign Aircraft to Location",
    "keepUnassigned": "Keep Unassigned",
    "current": "Current",
    "sections": {
      "hangars": "Hangars",
      "ramps": "Ramps"
    },
    "customTimeRange": "Custom time range",
    "fields": {
      "startTime": "Start Time",
      "endTime": "End Time"
    },
    "messages": {
      "noLocationsAvailable": "No locations available for the selected time period.",
      "unassignedPeriodsWarning": "Unassigned periods will be created before/after this time range"
    },
    "buttons": {
      "cancel": "Cancel",
      "assign": "Assign",
      "assigning": "Assigning..."
    }
  },
  "tripLocationNavigationDialog": {
    "title": "Trip at Different Location",
    "labels": {
      "tripLocation": "TRIP LOCATION",
      "youreViewing": "YOU'RE VIEWING"
    },
    "messages": {
      "unassignedTrip": "This trip hasn't been assigned to a specific location yet.",
      "unassignedExplanation": "You can view the time period when this trip is scheduled, but it doesn't have a hangar or ramp assignment.",
      "unassignedPrompt": "Choose whether to jump to this time period in your current view.",
      "assignedPrompt": "Choose whether to navigate to the trip's location or stay in your current view."
    },
    "buttons": {
      "cancel": "Cancel",
      "stayIn": "Stay in {{locationName}}",
      "goTo": "Go to {{locationName}}"
    }
  },
  "currentTimeControl": {
    "labels": {
      "currentTime": "Current Time",
      "viewing": "Viewing: {{startDate}} - {{endDate}}"
    },
    "buttons": {
      "now": "Now"
    }
  },
  "createTripDialog": {
    "title": {
      "create": "Create New Trip",
      "newTripFor": "New Trip for {{tailNumber}}"
    },
    "labels": {
      "ownerManager": "Owner/Manager",
      "type": "Type",
      "status": "Status",
      "searchAircraft": "Search by make and model",
      "arrivalDateTime": "Arrival Date & Time",
      "departureDateTime": "Departure Date & Time",
      "notes": "Notes",
      "noDeparture": "No departure",
      "required": "*"
    },
    "placeholders": {
      "ownerManager": "e.g., John Smith",
      "notes": "Any special requirements or notes..."
    },
    "tenantTypes": {
      "transient": "Transient",
      "base": "Base",
      "yellowCard": "Base + Yellow Card"
    },
    "messages": {
      "noScheduledDeparture": "This aircraft will remain at the FBO indefinitely with no scheduled departure.",
      "unassigned": "The aircraft will be initially placed as \"unassigned\" and can be positioned in a hangar or ramp area after creation.",
      "autoAssigned": "This trip will be automatically assigned to the current {{locationType}}.",
      "autoAssignedSimple": "The trip will be created for this aircraft and can be positioned after creation."
    },
    "buttons": {
      "cancel": "Cancel",
      "create": "Create Trip"
    },
    "tooltips": {
      "conflict": "Cannot create trip - overlaps with existing trip",
      "fillRequired": "Please fill in all required fields"
    }
  },
  "locationFilter": {
    "label": "Filter by Location",
    "placeholder": "All locations",
    "groups": {
      "hangars": "Hangars",
      "ramps": "Ramps"
    }
  },
  "tripEditForm": {
    "labels": {
      "tailNumber": "Tail Number",
      "ownerManager": "Owner/Manager",
      "aircraftModel": "Aircraft Model",
      "status": "Status",
      "arrival": "Arrival",
      "departure": "Departure",
      "notes": "Notes",
      "noDeparture": "No departure",
      "required": "*"
    },
    "placeholders": {
      "ownerManager": "Enter owner or manager name",
      "notes": "Add notes about this trip..."
    },
    "statuses": {
      "scheduled": "Scheduled",
      "active": "Active",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "messages": {
      "baseTenant": "Base Tenant",
      "noScheduledDeparture": "This aircraft has no scheduled departure",
      "indefiniteStay": "This aircraft will remain at the FBO indefinitely with no scheduled departure."
    },
    "buttons": {
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving..."
    }
  },
  "simpleBulkUpload": {
    "title": "Bulk Upload Trips",
    "pasteExcel": {
      "title": "Paste from Excel",
      "description": "Copy trip data from Excel (Tail Number, Arrival Date, Departure Date) and paste below. For base tenants, leave the departure column blank or use \"no departure\". Headers are optional and will be automatically detected and skipped.",
      "importButton": "Import Data",
      "importing": "Importing...",
      "sampleFileButton": "Sample File",
      "rowsReady": "{{count}} rows ready to import"
    },
    "editTrips": {
      "title": "Edit Trips",
      "tableHeaders": {
        "tailNumber": "Tail Number",
        "aircraft": "Aircraft",
        "arrivalDate": "Arrival Date",
        "departureDate": "Departure Date"
      },
      "addButton": "Add",
      "selectAircraft": "Select Aircraft",
      "placeholders": {
        "tailNumber": "N123AB"
      },
      "validationErrors": {
        "arrivalBeforeDeparture": "Arrival must be before departure",
        "departureAfterArrival": "Departure must be after arrival"
      }
    },
    "messages": {
      "autoAssign": "Trips will be automatically assigned to {{locationName}}",
      "validTripsCount": "{{count}} valid trips"
    },
    "buttons": {
      "cancel": "Cancel",
      "save": "Save {{count}} Trips"
    },
    "progress": {
      "uploadingTitle": "Uploading Trips",
      "uploadingMessage": "Creating trips and assigning to location. Please wait...",
      "itemName": "trip"
    },
    "sampleFile": {
      "header": "Tail Number\tArrival Date\tDeparture Date"
    },
    "errors": {
      "noActiveFBO": "No active FBO selected",
      "noValidTrips": "No valid trips to save",
      "missingAircraftData": "Cannot upload trips without aircraft data. Please select aircraft for: {{tailNumbers}}",
      "failedTenantSearch": "Failed to search for tenant: {{message}}",
      "missingAircraftId": "Internal error: trip missing aircraft_id for {{tailNumber}} - should be caught by validation",
      "failedTenantCreate": "Failed to create tenant: {{message}}",
      "assignmentFailed": "{{tailNumber}}: Trip created but assignment failed - {{message}}",
      "unknownError": "Unknown error",
      "tripCreationFailed": "{{tailNumber}}: {{message}}",
      "saveFailed": "Failed to save trips. Please try again."
    },
    "success": {
      "allSucceeded": "✓ Successfully added {{count}} trip{{locationMessage}}",
      "partialSuccess": "✓ Successfully added {{successCount}} out of {{totalCount}} trips{{locationMessage}}.\n\n✗ Failed {{failedCount}}:\n{{errors}}",
      "allFailed": "✗ Failed to add any trips:\n{{errors}}"
    },
    "successState": {
      "dialogTitle": "Upload Complete",
      "title": "Trips Created Successfully",
      "message": "{{count}} trip(s) have been added to the schedule.",
      "assignedTo": "Assigned to {{locationName}}.",
      "viewTrips": "View Trips",
      "done": "Done"
    }
  },
  "tripDetailsModal": {
    "title": "Trip Details",
    "buttons": {
      "newTrip": "New Trip",
      "view": "View",
      "edit": "Edit",
      "close": "Close",
      "cancelTrip": "Cancel Trip",
      "deleteTrip": "Delete Trip",
      "assignToLocation": "Assign to Location",
      "save": "Save",
      "saving": "Saving...",
      "deleting": "Deleting...",
      "cancelling": "Cancelling...",
      "cancel": "Cancel",
      "keepTrip": "Keep Trip"
    },
    "labels": {
      "tailNumber": "Tail Number",
      "ownerManager": "Owner/Manager",
      "aircraft": "Aircraft",
      "arrival": "Arrival",
      "departure": "Departure",
      "duration": "Duration",
      "notes": "Notes",
      "locationHistory": "Location History",
      "tripNavigation": "Trip Navigation"
    },
    "placeholders": {
      "ownerManager": "Enter owner or manager name",
      "notes": "Add notes...",
      "unknown": "Unknown",
      "noNotes": "No notes",
      "unassigned": "Unassigned"
    },
    "chips": {
      "transient": "Transient"
    },
    "duration": {
      "indefinite": "Indefinite",
      "days": "{{days}}d {{hours}}h {{minutes}}m",
      "hours": "{{hours}}h {{minutes}}m",
      "minutes": "{{minutes}}m"
    },
    "tableHeaders": {
      "location": "Location",
      "arrival": "Arrival",
      "departure": "Departure",
      "duration": "Duration"
    },
    "navigation": {
      "previous": "Previous: {{dates}}",
      "next": "Next: {{dates}}",
      "noOtherTrips": "No other trips"
    },
    "confirmations": {
      "deleteTitle": "Delete Trip",
      "deleteMessage": "Are you sure you want to permanently delete this trip for {{tailNumber}}? This action cannot be undone and will remove all placement history.",
      "cancelTitle": "Cancel Trip",
      "cancelMessage": "Are you sure you want to cancel this trip for {{tailNumber}}? This will change the trip status to \"cancelled\" and it cannot be easily undone."
    },
    "tooltips": {
      "unassigned": "Aircraft is not assigned to a specific hangar or ramp location during this time period. It may be in transient parking or awaiting placement assignment."
    }
  },
  "aircraftTripsModal": {
    "title": "Trips for {{tailNumber}}",
    "emptyState": {
      "title": "No trips found",
      "description": "This aircraft doesn't have any scheduled trips yet."
    },
    "tripCount": "Showing {{count}} trip",
    "clickToView": "Click a trip to view details",
    "viewingTrip": "Viewing trip for {{tailNumber}}",
    "duration": {
      "daysAndHours": "{{days}} day, {{hours}} hr",
      "hoursAndMinutes": "{{hours}} hr, {{minutes}} min",
      "minutes": "{{minutes}} min"
    },
    "tripDetails": {
      "title": "Trip Details",
      "editTooltip": "Edit trip",
      "unknown": "Unknown",
      "labels": {
        "aircraft": "Aircraft",
        "arrival": "Arrival",
        "departure": "Departure",
        "duration": "Duration",
        "notes": "Notes"
      }
    }
  },
  "scheduleListPage": {
    "alerts": {
      "selectFBO": "Select F B O"
    },
    "buttons": {
      "createFirstTrip": "Create First Trip",
      "createTrip": "Create Trip",
      "timelineView": "Timeline View"
    },
    "emptyState": {
      "description": "Description",
      "title": "Empty State"
    },
    "title": "Schedule List Page"
  }
}
